module.exports = __webpack_public_path__ + "media/components/lessons/statics/lesson3-c8b402b3efe8764a7ca3dbb9399e4d25.gif";